import {Injectable} from "@angular/core";
import {OrganisationDTO} from "./OrganisationDTO";
import {AbstractService} from "../../services/AbstractService";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {filter, map} from "rxjs/operators";
import {Observable} from "rxjs";
import {PageableResponse} from "./PageableResponse";
import {OrganisationOwnerDTO} from "./OrganisationOwnerDTO";

@Injectable({
  providedIn: 'root'
})
export class OrganisationService extends AbstractService<any> {
  protected constructor(protected override http: HttpClient) {
    super(http);
  }

  override getApiURL() {
    return "organisation";
  }

  createOrganisation(dto: OrganisationDTO) {
    return this.http.post(`${environment.apiUrl}${this.getApiURL()}/register`, dto, { observe: 'response' }).pipe(
      filter((res) => res.ok),
      map((res) => res.body)
    );
  }

  getById(id: number): Observable<OrganisationDTO> {
    return this.http.get<any>(`${environment.apiUrl}${this.getApiURL()}/${id}`);
  }

  filterOrganisations(params: any, searchData: any = {}): Observable<PageableResponse<OrganisationDTO>> {
    const url = `${environment.apiUrl}${this.getApiURL()}/filter`;

    return this.http.post<any>(url, searchData, { params }).pipe(
      map(response => {
        const pageableResponse = new PageableResponse<OrganisationDTO>(response.data);
        pageableResponse.content = pageableResponse.content.map(item => {
          const org = new OrganisationDTO();
          org.bindData(item);
          return org;
        });
        return pageableResponse;
      })
    );
  }
  getOrganisationAuthorizedUsers(owners: OrganisationOwnerDTO[]): Observable<any> {
    return this.http.post(`${environment.apiUrl}${this.getApiURL()}/get-organisation-authorized-users`,owners , {observe: 'response'}).pipe(
      filter((res) => res.ok),
      map((res) => res.body)
    );
  }
}
